import { useListCryptoContracts } from '../crypto_contracts'
import { useActiveFundInfo } from '../funds'
import { useVaultInfo } from '../vaults'

import type {
  AddressableSymbol,
  FundSymbol,
  VaultSymbol,
} from './products_names'

export function useGetTokenAddress({ symbol }: { symbol?: AddressableSymbol }) {
  const { data: fund } = useActiveFundInfo({ symbol: symbol as FundSymbol })
  const { data: vault } = useVaultInfo({ symbol: symbol as VaultSymbol })
  const {
    data: { contracts },
  } = useListCryptoContracts()

  if (fund) return fund.token_address
  if (vault) return vault.token_address
  return contracts.find((c) => c.symbol === symbol?.toUpperCase())?.address
}
